<div class="confirm-dialog-wrapper">
    <h1 id="confirmation-header">
        Attribute configuration
    </h1>

    <form [formGroup]="formulaFormGroup">
        <mat-form-field class="mr-8">
            <mat-select placeholder="Attribute"
                        formControlName="attributeCtrl"
                        required
            >
                <mat-option *ngFor="let attr of attributes" [value]="attr">
                    {{attr}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div>
            <h2>Apply Function (optional)</h2>

            <mat-form-field class="mr-8">
                <mat-select placeholder="Function"
                            formControlName="formulaCtrl"
                            [compareWith]="formulaComparisonFunction"
                >
                    <mat-option *ngFor="let formula of formulaOperations" [value]="formula">
                        {{formula.title}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <ng-container *ngIf="formulaCtrl?.value">
                <ng-container *ngFor="let argument of formulaCtrl.value.argumentsList">
                    <ng-container [ngSwitch]="argument.type">

                        <mat-form-field *ngSwitchCase="LOGIN_CREDENTIALS_FORMULA_TYPES.TEXT" class="mr-8">
                            <mat-label>{{argument.argumentFieldName}}</mat-label>
                            <input matInput
                                   [formControl]="formulaFormGroup.controls[argument.argumentFieldName]"
                                   [placeholder]="argument.argumentFieldName"
                                   type="text"
                                   [required]="true"
                            >
                        </mat-form-field>

                        <mat-form-field *ngSwitchCase="LOGIN_CREDENTIALS_FORMULA_TYPES.NUMBER" class="mr-8">
                            <mat-label>{{argument.argumentFieldName}}</mat-label>
                            <input matInput
                                   [formControl]="formulaFormGroup.controls[argument.argumentFieldName]"
                                   [placeholder]="argument.argumentFieldName"
                                   type="number"
                                   [maxlength]="argument.maxlength"
                                   [required]="true"
                            >
                        </mat-form-field>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </form>

    <div class="button-row">
        <button mat-button class="mr-8" (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" class="confirm-btn"
                (click)="onSubmit()" [disabled]="formulaFormGroup.invalid"
        >
            Apply
        </button>
    </div>
</div>
